import { cssTransition, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./toast.module.scss";

const AUTOCLOSE_TIMEOUT = 5000;
const DEBOUNCE_TIMEOUT = 5000;

const defaultOptions: ToastOptions = {
  position: toast.POSITION.BOTTOM_RIGHT,
  className: styles.toast,
  autoClose: AUTOCLOSE_TIMEOUT,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  transition: cssTransition({
    enter: styles.fadeIn,
    exit: styles.fadeOut,
    duration: 1000
  })
};

export function showToast(
  Component: (props?: any) => JSX.Element,
  options: Omit<ToastOptions, "delay"> & { delay?: number | boolean },
  props?: any
) {
  toast((toastProps: any) => <Component {...toastProps} {...props} />, {
    ...defaultOptions,
    ...options,
    delay: options.delay === true ? DEBOUNCE_TIMEOUT : options.delay || 0
  });
}

export function dismissToast(toastId: string) {
  toast.dismiss(toastId);
}
